
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorGenericInleftLeft50 as ObiThreewayAcuatorGenericInleftLeft50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-generic-inleft-left-50.js';
 
 
 

 
 export const ObiThreewayAcuatorGenericInleftLeft50 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-generic-inleft-left-50',
   elementClass: ObiThreewayAcuatorGenericInleftLeft50Element,
   events: {
     
   }
  });
 
 